module.exports = __webpack_public_path__ + "static/media/thyroid.13538192.svg";